import { CLOUD_FUNCTION_URLS, authenticatedFetch } from '../../utils/cloudFunctions';
import { normalizeAiResult } from './liveSpamCheck';

/**
 * Calls the Intelligent Spam Analyzer cloud function and returns a normalized
 * result ({level, score, triggers, notes, source:'ai'}) — or null on failure,
 * so callers can silently fall back to the local rule-based check.
 */
export async function requestAiSpamCheck({ subject = '', body = '', language, isFollowUp = false, userId = null }) {
  try {
    const response = await authenticatedFetch(CLOUD_FUNCTION_URLS.analyzeSpamRisk(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      // userId = active world, so a team member's check is billed to the team pool.
      body: JSON.stringify({ subject, body, language, isFollowUp, userId }),
    });
    if (!response.ok) return null;
    const data = await response.json();
    if (!data || data.error === 'analysis_unavailable' || data.score == null) return null;
    return normalizeAiResult(data);
  } catch (err) {
    console.warn('[SPAM-AI] analyzeSpamRisk failed, falling back to rules:', err.message);
    return null;
  }
}
